
import storage from 'redux-persist/lib/storage';
import { persistCombineReducers } from 'redux-persist';
import userReducers from './userReducers';

const persistConfig = {
  key: 'access',
  storage: storage,
  timeout: null,
}

const rootReducer = persistCombineReducers(persistConfig, {
  'user': userReducers,
});

export default rootReducer;
